import { lang } from '@umu/ukit-lang';
import './index.scss';
import React, { useEffect, useState } from 'react';
import { Iconfont, UmuInput } from '@umu/umu-design';
import { compileContent } from './dataFlow';
import { IfShow } from 'common/src/components';
import { useRequest } from 'ahooks';
import { onTransformNumberToChart } from '../../dataFlow/multiCapabilityTemplate';
interface IQuestionInfo {
    value: string;
    questionList: any[];
}
interface IProps {
    onChange: (data: IQuestionInfo) => void;
}
const defaultQuestionInfo: IQuestionInfo = {
    value: '',
    questionList: [],
};
const { Textarea } = UmuInput;

const BatchQuestion = (props: IProps) => {
    const { onChange } = props;
    const [value, setValue] = useState('');
    const onInfoChange = (data: IQuestionInfo) => {
        onChange(data);
    };
    const onTextChange = (val: string) => {
        return new Promise((resolve) => {
            const list = compileContent(val);

            const newInfo: IQuestionInfo = {
                value: val,
                questionList: list,
            };
            onInfoChange(newInfo);
            resolve(newInfo);
        });
    };
    const { data: info = defaultQuestionInfo, run } = useRequest(onTextChange, {
        debounceWait: 200,
        manual: true,
    });
    const renderQuestionList = () => {
        const { questionList = [] } = info as IQuestionInfo;
        return questionList.map((item, index) => {
            return (
                <li key={`question-${index}`} className="question-item">
                    <div className="question-item-title">{item.title}</div>
                    {item.list.map((option: any, optionIndex: number) => {
                        return (
                            <div key={`option-${optionIndex}`} className="question-option">
                                <span className="question-option-index">{onTransformNumberToChart(option.index)}.</span>
                                <span className="question-option-title">{option.title}</span>
                            </div>
                        );
                    })}
                </li>
            );
        });
    };
    useEffect(() => {
        run(value);
    }, [value]);
    return (
        <div className="multi-capability-question-batch-question">
            <div className="question-info">
                <div className="question-title">{lang('用两个回车分隔问题，用一个回车分隔选项')}</div>
                <div className="question-zone">
                    <IfShow show={!value}>
                        <div className="question-desc-tooltip">
                            <p>
                                {lang(
                                    '题目和题目之间空两行，选项单独一行。 批量输入的问题将添加在已有问题的下方，请您使用网页版继续进行问题高级设置等更多编辑。',
                                )}
                            </p>
                            <div className="line-info" />
                            <p>{lang('例子：')}</p>
                            <br />
                            <p>{lang('您更愿意成为亿万富翁，还是买东西永远不花钱？')}</p>
                            <p>{lang('成为亿万富翁')}</p>
                            <p>{lang('买东西永远不花钱')}</p>
                            <br />
                            <p>{lang('您更愿意与偶像共同环游世界，还是与挚爱一起流放孤岛？')}</p>
                            <p>{lang('与偶像环游世界')}</p>
                            <p>{lang('与挚爱流放孤岛')}</p>
                            <br />
                            <p>{lang('您的姓名')}</p>
                            <br />
                        </div>
                    </IfShow>
                    <div className="question-desc-input">
                        <Textarea
                            value={value}
                            onChange={({ value }) => setValue(value)}
                            expandConfig={{ autoSize: true }}
                        />
                    </div>
                </div>
            </div>
            <div className="question-info">
                <div className="question-title">{lang('预览')}</div>
                <div className="question-zone question-list">
                    <IfShow show={(info as any).questionList.length > 0}>
                        <ul className="question-list-zone">{renderQuestionList()}</ul>
                    </IfShow>
                    <IfShow show={(info as any).questionList.length === 0}>
                        <div className="question-info-empty">
                            <Iconfont type="AppletsFormBox" className="icon-empty-list" />
                            <div>{lang('暂时没有添加问题')}</div>
                        </div>
                    </IfShow>
                </div>
            </div>
        </div>
    );
};
export { BatchQuestion };
